module.exports = __webpack_public_path__ + "img/goldregen-2020-103.47bda0d0.jpg";